import { Injectable } from '@angular/core';
import { Action, NgxsOnInit, Selector, State, StateContext, StateToken } from '@ngxs/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ApiBookingService } from '../services';
import { SnackbarService } from '@fitscovery/ui/snackbar';

import { BookingControlState } from './booking-control-state';
import { BookingStateModel, Booking, BookingResponse, PartnerBooking } from '../models/booking.model';
import { BookingActions } from '../actions/booking.action';

export const bookingStateDefaults: BookingStateModel = {
  partnerBooking: null,
  bookings: null,
  loaded: false
};

export const BOOKING_STATE_TOKEN = new StateToken<BookingStateModel>('bookings');

@State<BookingStateModel>({
  name: BOOKING_STATE_TOKEN,
  defaults: bookingStateDefaults
})

@Injectable()
export class BookingState extends BookingControlState implements NgxsOnInit {

  @Selector()
  static bookingState(state: BookingStateModel): BookingStateModel {
    return state;
  }

  @Selector()
  static partnerBooking(state: BookingStateModel): PartnerBooking {
    return state.partnerBooking!;
  }

  @Selector()
  static bookings(state: BookingStateModel): Booking[] {
    return state.bookings!;
  }

  constructor(
    private bookingService: ApiBookingService,
    public override snackbar: SnackbarService
  ) {
    super(snackbar);
  }

  ngxsOnInit(): void {
  }

  @Action(BookingActions.GetPartnerBooking)
  getPartnerBooking(ctx: StateContext<BookingStateModel>, action: BookingActions.GetPartnerBooking): Observable<PartnerBooking | unknown> {
    return this.bookingService.getPartnerBooking(action.partnerId).pipe(
      tap((partnerBooking: PartnerBooking) => ctx.patchState({ partnerBooking, loaded: true })),
      this.catchResponse
    );
  }

  @Action(BookingActions.GetUpcomingBookings)
  getUpcomingBookings(ctx: StateContext<BookingStateModel>, action: BookingActions.GetUpcomingBookings): Observable<Booking[] | unknown> {
    return this.bookingService.getUpcomingBookings(action.partnerId).pipe(
      tap((bookings: Booking[]) => ctx.patchState({ bookings, loaded: true })),
      this.catchResponse
    );
  }

  @Action(BookingActions.UpdatePartnerBooking)
  updatePartnerBooking(ctx: StateContext<BookingStateModel>, action: BookingActions.UpdatePartnerBooking): Observable<PartnerBooking | unknown> {
    return this.bookingService.updatePartnerBooking(action.bookingDetails).pipe(
      tap((partnerBooking: PartnerBooking) => ctx.patchState({ partnerBooking })),
      this.catchResponse
    );
  }

  @Action(BookingActions.UpdateMemberBooking)
  updateMemberBooking(ctx: StateContext<BookingStateModel>, action: BookingActions.UpdateMemberBooking): Observable<any | unknown> {
    return this.bookingService.updateMemberBooking(action.bookingData).pipe(
      tap((bookingResponse: BookingResponse) => ctx.patchState({ bookings: this.updateBookingStatus(ctx, bookingResponse) })),
      this.catchResponse
    );
  }

}
